import React from 'react'
import { Redirect } from 'react-router-dom'
import PropTypes from 'prop-types'
import { ProductDiv } from '../shared/glamorous-style'
import glamorous from 'glamorous'
import { SuccessSvg } from '../shared/icons/svg-images'
import glamorousIcon from '../shared/icons'
import { graphql } from 'react-apollo'
import postCheckoutProcess from '../../graphql/postCheckoutProcess'
import { trackImpression } from '../../utils/analytics'
import URL from 'url-parse'
import { log } from '../../utils/error-tracking'
import trackCartEvent from '../../utils/track-cart-event'
import { flowRight as compose } from 'lodash'
import { Message } from '@paypalcorp/worldready-react'

const IconContainer = glamorous.div({
  paddingTop: '48px',
  paddingBottom: '20px',
})

const SuccessICON = glamorousIcon({
  '& svg': { height: '102', width: '102', fill: 'red' },
})

SuccessICON.defaultProps = { svg: SuccessSvg }

const Content = glamorous.div({
  backgroundColor: '#ffffff',
  textAlign: 'center',
  margin: '0 115px 0 117px',
  '@media only screen and (max-width: 768px)': {
    margin: '0 12px',
  },
})

const Header = glamorous.div(
  {
    fontSize: '20px',
    color: '#2c2e2f',
    paddingBottom: '24px',
  },
  'vx_text-4_regular',
)

const OrderNumber = glamorous.div({
  fontSize: '20px',
  color: '#4a4a4a',
  paddingBottom: '36px',
})

const Note = glamorous.div(
  {
    fontSize: '18px',
    color: '#2b2b2b',
    paddingBottom: '36px',
    textAlign: 'left',
  },
  'vx_text-body-lg',
)

const Button = glamorous.button({
  marginBottom: '16px',
  width: '270px',
  '@media only screen and (max-width: 768px)': {
    width: '271px',
  },
})

const GoToSummary = glamorous.a({
  textDecoration: 'none',
  fontSize: '15px',
})

const SummaryLink = glamorous.div({
  paddingBottom: '30px',
  width: '111px',
  margin: '0 auto',
})

export class Success extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    postCheckoutProcess: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      error: false,
      recipientEmail: '',
      inContextFlow: false,
    }
  }

  componentDidMount() {
    const paymentInfo = this.getPaymentInfo()

    // redirect back to home if user came directly to page
    if (!paymentInfo.payerId || !paymentInfo.paymentId) {
      this.props.history.replace('/')
      return
    }

    const params = new URL(window.location, true).query
    const mfKey = params.mfKey || localStorage.getItem('cart_id')

    this.props
      .postCheckoutProcess({
        variables: { paymentInfo, mfKey },
      })
      .then(({ data }) => {
        if (data.postCheckoutProcess.userCountryAllowedForTxn === false) {
          this.redirectToXBorderError(paymentInfo.payerId)
          return
        }

        if (data.postCheckoutProcess.isPurchaseLimitExceeded) {
          this.redirectToPromotionError(paymentInfo.payerId)
          return
        }

        if (data.postCheckoutProcess.velocityLimitErrors) {
          this.redirectToVelocityError(
            paymentInfo.payerId,
            data.postCheckoutProcess.velocityLimitErrors,
          )
          return
        }

        if (!data.postCheckoutProcess.isExecutePaymentSuccess) {
          this.redirectToError(paymentInfo.payerId)
          return
        }

        if (!data.postCheckoutProcess.isOrderSuccess) {
          this.logTxnIdRedirectToError(
            paymentInfo.payerId,
            data.postCheckoutProcess.transaction.txnId,
          )

          return
        }

        this.orderReference = data.postCheckoutProcess.transaction.txnId

        const {
          recipientEmail,
          inContextFlow,
        } = data.postCheckoutProcess.orderDetails

        this.setState({
          error: false,
          loading: false,
          recipientEmail,
          inContextFlow,
        })

        if (inContextFlow) document.body.classList.add('in-context-flow')

        localStorage.removeItem('cart_id')

        trackImpression(
          'main:consumer:gifts:cart:',
          'main:consumer:gifts:cart:success:::',
          {
            txn_id: this.orderReference || null,
            entry_point: inContextFlow ? 'P2P' : 'PPDG_STOREFRONT',
          },
        )

        trackCartEvent('purchase')

        return
      })
      .catch((reason) => {
        log({
          file: 'success',
          err: {
            stack: `Exception in execute payment and create order for payerId ${
              paymentInfo.payerId
            }, redirect to error page. Error : ${JSON.stringify(reason)}`,
          },
        })

        this.props.history.replace('/error')
      })
  }

  getPaymentInfo = () => {
    const params = new URL(window.location, true).query
    const payerId = params.PayerID
    const paymentId = params.paymentId
    const paymentInfo = {
      payerId,
      paymentId,
    }
    return paymentInfo
  }

  redirectToXBorderError = (payerId) => {
    log({
      file: 'success',
      err: {
        stack: `Failed in execute payment for payerId ${payerId} due to x-border`,
      },
    })
    this.props.history.replace('/txnerror')
  }

  redirectToPromotionError = (payerId) => {
    log({
      file: 'success',
      err: {
        stack: `Purchase limit exceeded for ${payerId}, redirect to promotion error page`,
      },
    })
    this.props.history.replace('/promotionerror')
  }

  redirectToVelocityError = (payerId, velocityLimitErrors) => {
    log({
      file: 'success',
      err: {
        stack: `Velocity purchase limit exceeded for ${payerId}, redirect to velocity error page`,
      },
    })
    this.props.history.replace('/txnerror', { velocityLimitErrors })
  }

  redirectToError = (payerId) => {
    log({
      file: 'success',
      err: {
        stack: `Failed in execute payment for payerId ${payerId}, redirect to error page`,
      },
    })
    this.props.history.push('/error')
  }

  logTxnIdRedirectToError = (payerId, txnId) => {
    log({
      file: 'success',
      err: {
        stack: `Failed in create order for payerId ${payerId}, txnId: ${txnId}, redirect to error page`,
      },
    })
    this.props.history.push('/error')
  }

  handleContinue = () => {
    this.props.history.push('/all')
  }

  redirectToSendNRequest = () => {
    window.location.replace('/myaccount/transfer/homepage')
  }

  renderMessage = () => {
    const { inContextFlow, recipientEmail } = this.state
    return (
      <div>
        <Header id="success-title" style={{}}>
          <Message id="pages/success.success.header" />
        </Header>
        <OrderNumber>
          <Message
            id="pages/success.success.orderNumber"
            orderNumber={this.orderReference}
          />
        </OrderNumber>
        {inContextFlow ? (
          <React.Fragment>
            <OrderNumber>
              <Message id="pages/success.success.emailText" /> {recipientEmail}
            </OrderNumber>
            <Note>
              <Message id="pages/success.success.orderInfo" />
            </Note>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Note>
              <Message id="pages/success.success.messageTop" />
            </Note>
            <Note>
              <Message id="pages/success.success.messageMiddle" />
            </Note>
            <Note>
              <Message id="pages/success.success.messageBottom" />
            </Note>
          </React.Fragment>
        )}
      </div>
    )
  }

  render() {
    const { inContextFlow } = this.state
    if (this.state.loading) {
      return (
        <div
          data-testid="loading"
          className="vx_has-spinner-large"
          style={{ paddingTop: '400px' }}
        />
      )
    }
    if (this.state.error) {
      return <Redirect to="/error" />
    }

    return (
      <div id="success-page" className="container">
        <ProductDiv>
          <Content id="content">
            <IconContainer id="icon">
              <SuccessICON />
            </IconContainer>
            {this.renderMessage()}
            {inContextFlow ? (
              <React.Fragment>
                <Button
                  className="vx_btn vx_btn-primary"
                  name="GoToSendNRequestButton"
                  onClick={this.redirectToSendNRequest}
                  data-pageName="main:consumer:gifts:cart:success"
                >
                  <Message id="pages/success.success.goToSendNRequest" />
                </Button>
                <SummaryLink className="row">
                  <GoToSummary
                    href="/myaccount/summary"
                    data-pageName="main:consumer:gifts:cart:success"
                  >
                    <Message id="pages/success.success.goToSummary" />
                  </GoToSummary>
                </SummaryLink>
              </React.Fragment>
            ) : (
              <Button
                className="vx_btn vx_btn-secondary"
                name="SuccessDoneButton"
                onClick={this.handleContinue}
              >
                <Message id="pages/success.success.done" />
              </Button>
            )}
          </Content>
        </ProductDiv>
      </div>
    )
  }
}

const SuccessWithMutation = compose(
  graphql(postCheckoutProcess, {
    name: 'postCheckoutProcess',
  }),
)(Success)

export default SuccessWithMutation
